import { Dispatch } from "redux";
import { setOrganizationDetails, setOrganizationDetailsLoading } from "@redux/actions/organization-details-actions";
import { getOrganizationConfig } from "@requests/axnadmin-core";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { OrganizationConfig } from "@idw-types/data/organization-config";

export const getOrganizationDetailsReduxRequest = (dispatch: Dispatch) => async (
    axnCompanyId: string
): Promise<OrganizationConfig> => {
    dispatch(setOrganizationDetailsLoading(true));
    const { data, error } = await getOrganizationConfig(axnCompanyId);
    if (data) {
        dispatch(setOrganizationDetails(data));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getOrganizationDetails.error.title,
                resources.requests.getOrganizationDetails.error.message
            );
        }
        dispatch(setOrganizationDetailsLoading(false));
        return null;
    }
};